/** @jsxImportSource @emotion/react */
import {css} from '@emotion/react'



const styles = {
  root: css`
    display: flex;
    flex-direction: column;
    margin-bottom: 10px;
  `,
  contentContainer: css`
    display: flex;
    align-items: flex-start;
  `,
  icon: css`
    margin-right: 10px;
    display: flex;
    align-items: center;
  `,
  title: css`
    font-weight: 500;
    margin: 0;
    font-size: 1rem;
  `,
  text: css`
    white-space: pre-wrap;
    word-wrap: break-word;
    max-width: 100%;
    line-height: 1.3;
    margin: 0;
    color: #c2c2c2;
    font-family: neue-haas-unica, 'Helvetica Neue', Roboto, -apple-system, Arial, sans-serif;
  `
}



const DetailPageSection = ({ icon, title, text, subtext, Content, SubContent, ...rest }) => {
  const passedStyles = rest.styles || {}


  return (
    <div css={styles.root} style={{...passedStyles}}>
      <div css={styles.contentContainer}>
        {icon && 
          <div css={styles.icon}>
            {icon}
          </div> 
        }
        
        <div>
          {title && 
            <h4 css={styles.title}>
              {title}
            </h4>
          }

          {text &&
            <pre css={styles.text}>
              {text}
            </pre>
          }

          {subtext &&
            <p css={styles.text}>
              {subtext}
            </p>
          }

          {Boolean(Content) && Content}
          {Boolean(SubContent) && SubContent}
        </div>
      </div>
    </div>
  )
}


export default DetailPageSection




